import { createContext, useState } from "react";

export const SignInModalContext = createContext({
  openSignInModal: false,
  setOpenSignInModal: () => false,
});

export const SignInModalProvider = ({ children }) => {
  const [openSignInModal, setOpenSignInModal] = useState(false);
  const value = { openSignInModal, setOpenSignInModal };
  return (
    <SignInModalContext.Provider value={value}>
      {children}
    </SignInModalContext.Provider>
  );
};
